module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_11a-5e1d420f660f7c26316ca7d1d4f3de52.jpg";